"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWorkflowStatuses = void 0;
const react_1 = require("react");
const workflow_1 = require("@sierralabs/workflow");
const workflow_core_1 = require("@sierralabs/workflow-core");
function useWorkflowStatuses(workflowDto) {
    const workflow = (0, react_1.useMemo)(() => {
        return workflowDto instanceof workflow_1.Workflow
            ? workflowDto
            : (workflowDto === null || workflowDto === void 0 ? void 0 : workflowDto.config) && new workflow_1.Workflow(workflowDto.config);
    }, [workflowDto]);
    return (0, react_1.useMemo)(() => {
        if (!workflow) {
            return [];
        }
        // filter out root state node
        const rootNode = `/${workflow.stateNode.name}`;
        return workflow
            .getAllPaths()
            .filter((path) => path !== rootNode)
            .map(workflow_core_1.parseTaskStatus);
    }, [workflow]);
}
exports.useWorkflowStatuses = useWorkflowStatuses;
//# sourceMappingURL=useWorkflowStatuses.js.map